var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1621,
    viewBox: "0 0 1920 1621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1164,
    y: 1558,
    width: 29,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1192.39 1561.95L1182.75 1587.46L1164 1584.32L1173.64 1558.82L1192.39 1561.95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1187.08 1575.98C1185.26 1576.09 1183.86 1575.73 1182.41 1575.59C1180.7 1575.43 1179.42 1576.44 1178.15 1577.78C1176.92 1579.1 1175.83 1580.57 1174.9 1582.16C1174.62 1582.64 1174.41 1583.24 1173.8 1583.41C1173.26 1582.9 1173.77 1582.12 1174 1581.52C1174.54 1580.21 1174.76 1578.9 1174.95 1577.63C1175.29 1575.59 1174.61 1574.1 1173.13 1573.34C1171.99 1572.75 1170.76 1572.3 1169.57 1571.79C1169.22 1571.65 1168.78 1571.57 1169.08 1570.93C1169.31 1570.46 1169.69 1570.58 1170.01 1570.58C1171.29 1570.54 1172.54 1570.57 1173.83 1570.47C1175.87 1570.31 1177.49 1569.07 1178.76 1566.92C1179.71 1565.33 1180.41 1563.68 1181.11 1562.02C1181.34 1561.48 1181.57 1560.89 1182.17 1560.9C1182.76 1560.91 1182.69 1561.48 1182.6 1562.05C1182.44 1563.03 1182.32 1564.02 1182.16 1565.01C1181.46 1569.18 1182.81 1571.97 1185.33 1574.01C1185.92 1574.49 1186.86 1574.61 1187.08 1575.98Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 693,
    y: 856,
    width: 29,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M721.967 859.604L712.325 885.105L693.575 881.974L703.217 856.473L721.967 859.604Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.658 873.63C714.839 873.742 713.436 873.379 711.986 873.244C710.273 873.077 708.993 874.094 707.728 875.432C706.491 876.751 705.401 878.224 704.475 879.808C704.192 880.293 703.987 880.885 703.373 881.055C702.837 880.552 703.34 879.773 703.577 879.174C704.117 877.857 704.331 876.546 704.528 875.278C704.861 873.241 704.183 871.746 702.703 870.992C701.563 870.4 700.332 869.948 699.14 869.442C698.791 869.301 698.352 869.217 698.652 868.581C698.88 868.111 699.265 868.234 699.582 868.227C700.862 868.192 702.116 868.223 703.403 868.118C705.445 867.961 707.066 866.717 708.336 864.565C709.28 862.984 709.988 861.329 710.687 859.672C710.912 859.131 711.145 858.543 711.742 858.548C712.335 858.563 712.266 859.131 712.179 859.696C712.01 860.684 711.891 861.669 711.73 862.659C711.036 866.834 712.381 869.622 714.904 871.661C715.498 872.138 716.434 872.258 716.658 873.63Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 944,
    y: 1204,
    width: 29,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M972.948 1207.2L963.305 1232.7L944.555 1229.57L954.198 1204.07L972.948 1207.2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967.639 1221.23C965.82 1221.34 964.417 1220.98 962.967 1220.84C961.253 1220.67 959.974 1221.69 958.709 1223.03C957.472 1224.35 956.381 1225.82 955.456 1227.41C955.173 1227.89 954.968 1228.48 954.353 1228.65C953.818 1228.15 954.32 1227.37 954.558 1226.77C955.098 1225.45 955.312 1224.14 955.509 1222.88C955.841 1220.84 955.163 1219.34 953.683 1218.59C952.544 1218 951.312 1217.55 950.121 1217.04C949.772 1216.9 949.333 1216.81 949.633 1216.18C949.861 1215.71 950.246 1215.83 950.563 1215.83C951.842 1215.79 953.097 1215.82 954.383 1215.72C956.426 1215.56 958.047 1214.32 959.317 1212.16C960.261 1210.58 960.969 1208.93 961.667 1207.27C961.893 1206.73 962.126 1206.14 962.723 1206.15C963.316 1206.16 963.247 1206.73 963.16 1207.29C962.991 1208.28 962.871 1209.27 962.711 1210.26C962.017 1214.43 963.362 1217.22 965.885 1219.26C966.479 1219.74 967.415 1219.86 967.639 1221.23Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1639,
    y: 452,
    width: 30,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1668.14 455.37L1658.5 480.871L1639.75 477.74L1649.39 452.239L1668.14 455.37Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1662.83 469.397C1661.01 469.508 1659.61 469.145 1658.16 469.01C1656.45 468.844 1655.17 469.86 1653.9 471.199C1652.67 472.517 1651.58 473.991 1650.65 475.574C1650.37 476.059 1650.16 476.652 1649.55 476.821C1649.01 476.319 1649.51 475.539 1649.75 474.941C1650.29 473.624 1650.51 472.312 1650.7 471.045C1651.04 469.008 1650.36 467.513 1648.88 466.758C1647.74 466.167 1646.51 465.714 1645.31 465.209C1644.97 465.068 1644.53 464.983 1644.83 464.348C1645.06 463.877 1645.44 464 1645.76 463.994C1647.04 463.958 1648.29 463.99 1649.58 463.884C1651.62 463.727 1653.24 462.484 1654.51 460.331C1655.46 458.751 1656.16 457.096 1656.86 455.439C1657.09 454.897 1657.32 454.31 1657.92 454.314C1658.51 454.33 1658.44 454.898 1658.35 455.462C1658.18 456.451 1658.07 457.435 1657.91 458.425C1657.21 462.6 1658.56 465.389 1661.08 467.427C1661.67 467.904 1662.61 468.024 1662.83 469.397Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1846,
    y: 874,
    width: 29,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1874.39 877.954L1864.75 903.455L1846 900.324L1855.64 874.823L1874.39 877.954Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1869.08 891.981C1867.26 892.092 1865.86 891.729 1864.41 891.594C1862.7 891.428 1861.42 892.444 1860.15 893.782C1858.92 895.101 1857.83 896.575 1856.9 898.158C1856.62 898.643 1856.41 899.236 1855.8 899.405C1855.26 898.903 1855.77 898.123 1856 897.525C1856.54 896.208 1856.76 894.896 1856.95 893.629C1857.29 891.592 1856.61 890.097 1855.13 889.342C1853.99 888.751 1852.76 888.298 1851.57 887.793C1851.22 887.652 1850.78 887.567 1851.08 886.932C1851.31 886.461 1851.69 886.584 1852.01 886.578C1853.29 886.542 1854.54 886.574 1855.83 886.468C1857.87 886.311 1859.49 885.068 1860.76 882.915C1861.71 881.335 1862.41 879.68 1863.11 878.023C1863.34 877.481 1863.57 876.894 1864.17 876.898C1864.76 876.914 1864.69 877.482 1864.6 878.046C1864.44 879.035 1864.32 880.019 1864.16 881.009C1863.46 885.184 1864.81 887.973 1867.33 890.011C1867.92 890.488 1868.86 890.608 1869.08 891.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 839,
    width: 29,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.393 842.954L350.75 868.455L332.001 865.324L341.643 839.823L360.393 842.954Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.084 856.981C353.265 857.092 351.862 856.729 350.411 856.594C348.698 856.428 347.419 857.444 346.154 858.782C344.916 860.101 343.826 861.575 342.9 863.158C342.618 863.643 342.412 864.236 341.798 864.405C341.263 863.903 341.765 863.123 342.003 862.525C342.543 861.208 342.757 859.896 342.954 858.629C343.286 856.592 342.608 855.097 341.128 854.342C339.989 853.751 338.757 853.298 337.565 852.793C337.216 852.652 336.777 852.567 337.078 851.932C337.306 851.461 337.691 851.584 338.008 851.578C339.287 851.542 340.542 851.574 341.828 851.468C343.87 851.311 345.492 850.068 346.761 847.915C347.706 846.335 348.414 844.68 349.112 843.023C349.338 842.481 349.571 841.894 350.168 841.898C350.761 841.914 350.692 842.482 350.605 843.046C350.435 844.035 350.316 845.019 350.156 846.009C349.462 850.184 350.807 852.973 353.33 855.011C353.924 855.488 354.86 855.608 355.084 856.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 958,
    y: 789,
    width: 26,
    height: 27
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M983.567 792.561L974.884 815.524L958.001 812.704L966.683 789.741L983.567 792.561Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M978.786 805.192C977.149 805.292 975.885 804.965 974.579 804.844C973.036 804.694 971.884 805.609 970.745 806.814C969.631 808.002 968.649 809.328 967.816 810.754C967.561 811.191 967.376 811.724 966.823 811.877C966.341 811.424 966.793 810.723 967.007 810.184C967.493 808.998 967.686 807.817 967.864 806.675C968.163 804.841 967.553 803.495 966.22 802.816C965.194 802.283 964.085 801.875 963.012 801.42C962.697 801.294 962.302 801.217 962.573 800.645C962.778 800.221 963.125 800.332 963.41 800.326C964.562 800.294 965.692 800.322 966.85 800.228C968.689 800.086 970.149 798.967 971.292 797.028C972.143 795.605 972.78 794.115 973.409 792.623C973.612 792.135 973.822 791.606 974.36 791.61C974.893 791.624 974.832 792.135 974.753 792.644C974.601 793.534 974.493 794.421 974.349 795.312C973.724 799.071 974.935 801.582 977.207 803.418C977.742 803.847 978.585 803.955 978.786 805.192Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 507,
    width: 29,
    height: 30
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3936 510.954L39.7511 536.455L21.0013 533.324L30.6437 507.823L49.3936 510.954Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0848 524.981C42.2659 525.092 40.8629 524.729 39.4124 524.594C37.6991 524.428 36.4195 525.444 35.155 526.782C33.9174 528.101 32.8273 529.575 31.9014 531.158C31.6189 531.643 31.4134 532.236 30.7992 532.405C30.2639 531.903 30.7663 531.123 31.0037 530.525C31.5435 529.208 31.7576 527.896 31.9547 526.629C32.2873 524.592 31.6092 523.097 30.1292 522.342C28.9896 521.751 27.7582 521.298 26.5663 520.793C26.2174 520.652 25.7785 520.567 26.079 519.932C26.3068 519.461 26.6919 519.584 27.0085 519.578C28.2882 519.542 29.5425 519.574 30.8291 519.468C32.8715 519.311 34.4926 518.068 35.7624 515.915C36.7068 514.335 37.4146 512.68 38.1131 511.023C38.3386 510.481 38.5718 509.894 39.1688 509.898C39.7615 509.914 39.6929 510.482 39.6059 511.046C39.4363 512.035 39.3171 513.019 39.1568 514.009C38.4629 518.184 39.8077 520.973 42.3307 523.011C42.9248 523.488 43.8607 523.608 44.0848 524.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 962,
    y: 545,
    width: 29,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M990.393 548.954L980.75 574.455L962 571.324L971.643 545.823L990.393 548.954Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M985.084 562.981C983.265 563.092 981.862 562.729 980.411 562.594C978.698 562.428 977.418 563.444 976.154 564.782C974.916 566.101 973.826 567.575 972.9 569.158C972.618 569.643 972.412 570.236 971.798 570.405C971.263 569.903 971.765 569.123 972.002 568.525C972.542 567.208 972.756 565.896 972.953 564.629C973.286 562.592 972.608 561.097 971.128 560.342C969.988 559.751 968.757 559.298 967.565 558.793C967.216 558.652 966.777 558.567 967.078 557.932C967.306 557.461 967.691 557.584 968.007 557.578C969.287 557.542 970.541 557.574 971.828 557.468C973.87 557.311 975.491 556.068 976.761 553.915C977.706 552.335 978.413 550.68 979.112 549.023C979.337 548.481 979.571 547.894 980.168 547.898C980.76 547.914 980.692 548.482 980.605 549.046C980.435 550.035 980.316 551.019 980.156 552.009C979.462 556.184 980.806 558.973 983.33 561.011C983.924 561.488 984.859 561.608 985.084 562.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 959,
    y: 272,
    width: 29,
    height: 30
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M987.393 275.954L977.75 301.455L959.001 298.324L968.643 272.823L987.393 275.954Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M982.084 289.981C980.265 290.092 978.862 289.729 977.411 289.594C975.698 289.428 974.419 290.444 973.154 291.782C971.916 293.101 970.826 294.575 969.9 296.158C969.618 296.643 969.412 297.236 968.798 297.405C968.263 296.903 968.765 296.123 969.003 295.525C969.543 294.208 969.757 292.896 969.954 291.629C970.286 289.592 969.608 288.097 968.128 287.342C966.989 286.751 965.757 286.298 964.565 285.793C964.216 285.652 963.777 285.567 964.078 284.932C964.306 284.461 964.691 284.584 965.008 284.578C966.287 284.542 967.542 284.574 968.828 284.468C970.87 284.311 972.492 283.068 973.761 280.915C974.706 279.335 975.414 277.68 976.112 276.023C976.338 275.481 976.571 274.894 977.168 274.898C977.761 274.914 977.692 275.482 977.605 276.046C977.435 277.035 977.316 278.019 977.156 279.009C976.462 283.184 977.807 285.973 980.33 288.011C980.924 288.488 981.86 288.608 982.084 289.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 607,
    y: 118,
    width: 29,
    height: 30
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M635.393 121.954L625.75 147.455L607.001 144.324L616.643 118.823L635.393 121.954Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.084 135.981C628.265 136.092 626.862 135.729 625.411 135.594C623.698 135.428 622.419 136.444 621.154 137.782C619.916 139.101 618.826 140.575 617.9 142.158C617.618 142.643 617.412 143.236 616.798 143.405C616.263 142.903 616.765 142.123 617.003 141.525C617.543 140.208 617.757 138.896 617.954 137.629C618.286 135.592 617.608 134.097 616.128 133.342C614.989 132.751 613.757 132.298 612.565 131.793C612.216 131.652 611.777 131.567 612.078 130.932C612.306 130.461 612.691 130.584 613.008 130.578C614.287 130.542 615.542 130.574 616.828 130.468C618.87 130.311 620.492 129.068 621.761 126.915C622.706 125.335 623.414 123.68 624.112 122.023C624.338 121.481 624.571 120.894 625.168 120.898C625.761 120.914 625.692 121.482 625.605 122.046C625.435 123.035 625.316 124.019 625.156 125.009C624.462 129.184 625.807 131.973 628.33 134.011C628.924 134.488 629.86 134.608 630.084 135.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1524,
    y: 335,
    width: 29,
    height: 30
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.39 338.954L1542.75 364.455L1524 361.324L1533.64 335.823L1552.39 338.954Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1547.08 352.981C1545.27 353.092 1543.86 352.729 1542.41 352.594C1540.7 352.428 1539.42 353.444 1538.15 354.782C1536.92 356.101 1535.83 357.575 1534.9 359.158C1534.62 359.643 1534.41 360.236 1533.8 360.405C1533.26 359.903 1533.77 359.123 1534 358.525C1534.54 357.208 1534.76 355.896 1534.95 354.629C1535.29 352.592 1534.61 351.097 1533.13 350.342C1531.99 349.751 1530.76 349.298 1529.57 348.793C1529.22 348.652 1528.78 348.567 1529.08 347.932C1529.31 347.461 1529.69 347.584 1530.01 347.578C1531.29 347.542 1532.54 347.574 1533.83 347.468C1535.87 347.311 1537.49 346.068 1538.76 343.915C1539.71 342.335 1540.41 340.68 1541.11 339.023C1541.34 338.481 1541.57 337.894 1542.17 337.898C1542.76 337.914 1542.69 338.482 1542.61 339.046C1542.44 340.035 1542.32 341.019 1542.16 342.009C1541.46 346.184 1542.81 348.973 1545.33 351.011C1545.92 351.488 1546.86 351.608 1547.08 352.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 694,
    y: 1231,
    width: 29,
    height: 30
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M722.394 1234.95L712.751 1260.46L694.001 1257.32L703.644 1231.82L722.394 1234.95Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.085 1248.98C715.266 1249.09 713.863 1248.73 712.412 1248.59C710.699 1248.43 709.419 1249.44 708.155 1250.78C706.917 1252.1 705.827 1253.57 704.901 1255.16C704.619 1255.64 704.413 1256.24 703.799 1256.41C703.264 1255.9 703.766 1255.12 704.003 1254.52C704.543 1253.21 704.757 1251.9 704.954 1250.63C705.287 1248.59 704.609 1247.1 703.129 1246.34C701.989 1245.75 700.758 1245.3 699.566 1244.79C699.217 1244.65 698.778 1244.57 699.079 1243.93C699.307 1243.46 699.692 1243.58 700.008 1243.58C701.288 1243.54 702.542 1243.57 703.829 1243.47C705.871 1243.31 707.492 1242.07 708.762 1239.92C709.707 1238.33 710.414 1236.68 711.113 1235.02C711.338 1234.48 711.572 1233.89 712.169 1233.9C712.761 1233.91 712.693 1234.48 712.606 1235.05C712.436 1236.03 712.317 1237.02 712.157 1238.01C711.463 1242.18 712.807 1244.97 715.33 1247.01C715.925 1247.49 716.86 1247.61 717.085 1248.98Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 1291,
    width: 29,
    height: 30
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360.394 1294.95L350.751 1320.46L332.001 1317.32L341.644 1291.82L360.394 1294.95Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.085 1308.98C353.266 1309.09 351.863 1308.73 350.412 1308.59C348.699 1308.43 347.419 1309.44 346.155 1310.78C344.917 1312.1 343.827 1313.57 342.901 1315.16C342.619 1315.64 342.413 1316.24 341.799 1316.41C341.264 1315.9 341.766 1315.12 342.003 1314.52C342.543 1313.21 342.757 1311.9 342.954 1310.63C343.287 1308.59 342.609 1307.1 341.129 1306.34C339.989 1305.75 338.758 1305.3 337.566 1304.79C337.217 1304.65 336.778 1304.57 337.079 1303.93C337.307 1303.46 337.692 1303.58 338.008 1303.58C339.288 1303.54 340.542 1303.57 341.829 1303.47C343.871 1303.31 345.492 1302.07 346.762 1299.92C347.707 1298.33 348.414 1296.68 349.113 1295.02C349.338 1294.48 349.572 1293.89 350.169 1293.9C350.761 1293.91 350.693 1294.48 350.606 1295.05C350.436 1296.03 350.317 1297.02 350.157 1298.01C349.463 1302.18 350.807 1304.97 353.33 1307.01C353.925 1307.49 354.86 1307.61 355.085 1308.98Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1279,
    y: 1116,
    width: 29,
    height: 30
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.39 1119.95L1297.75 1145.46L1279 1142.32L1288.64 1116.82L1307.39 1119.95Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302.08 1133.98C1300.27 1134.09 1298.86 1133.73 1297.41 1133.59C1295.7 1133.43 1294.42 1134.44 1293.15 1135.78C1291.92 1137.1 1290.83 1138.57 1289.9 1140.16C1289.62 1140.64 1289.41 1141.24 1288.8 1141.41C1288.26 1140.9 1288.77 1140.12 1289 1139.52C1289.54 1138.21 1289.76 1136.9 1289.95 1135.63C1290.29 1133.59 1289.61 1132.1 1288.13 1131.34C1286.99 1130.75 1285.76 1130.3 1284.57 1129.79C1284.22 1129.65 1283.78 1129.57 1284.08 1128.93C1284.31 1128.46 1284.69 1128.58 1285.01 1128.58C1286.29 1128.54 1287.54 1128.57 1288.83 1128.47C1290.87 1128.31 1292.49 1127.07 1293.76 1124.92C1294.71 1123.33 1295.41 1121.68 1296.11 1120.02C1296.34 1119.48 1296.57 1118.89 1297.17 1118.9C1297.76 1118.91 1297.69 1119.48 1297.61 1120.05C1297.44 1121.03 1297.32 1122.02 1297.16 1123.01C1296.46 1127.18 1297.81 1129.97 1300.33 1132.01C1300.92 1132.49 1301.86 1132.61 1302.08 1133.98Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1784,
    y: 727,
    width: 29,
    height: 30
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.51 730.782L1802.87 756.283L1784.12 753.153L1793.76 727.651L1812.51 730.782Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1807.2 744.809C1805.38 744.92 1803.98 744.557 1802.53 744.423C1800.82 744.256 1799.54 745.272 1798.27 746.611C1797.04 747.93 1795.94 749.403 1795.02 750.987C1794.74 751.471 1794.53 752.064 1793.92 752.234C1793.38 751.731 1793.88 750.952 1794.12 750.353C1794.66 749.036 1794.88 747.724 1795.07 746.457C1795.4 744.42 1794.73 742.925 1793.25 742.17C1792.11 741.579 1790.88 741.126 1789.68 740.621C1789.34 740.48 1788.9 740.395 1789.2 739.76C1789.42 739.289 1789.81 739.413 1790.13 739.406C1791.41 739.371 1792.66 739.402 1793.95 739.297C1795.99 739.14 1797.61 737.896 1798.88 735.743C1799.82 734.163 1800.53 732.508 1801.23 730.851C1801.46 730.309 1801.69 729.722 1802.29 729.726C1802.88 729.742 1802.81 730.31 1802.72 730.875C1802.55 731.863 1802.43 732.848 1802.27 733.837C1801.58 738.012 1802.93 740.801 1805.45 742.839C1806.04 743.316 1806.98 743.436 1807.2 744.809Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1459,
    y: 1085,
    width: 30,
    height: 29
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.24 1088.37L1478.59 1113.88L1459.84 1110.74L1469.49 1085.24L1488.24 1088.37Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1482.93 1102.4C1481.11 1102.51 1479.7 1102.15 1478.25 1102.01C1476.54 1101.85 1475.26 1102.86 1474 1104.2C1472.76 1105.52 1471.67 1106.99 1470.74 1108.58C1470.46 1109.06 1470.26 1109.66 1469.64 1109.83C1469.11 1109.32 1469.61 1108.54 1469.85 1107.94C1470.39 1106.63 1470.6 1105.32 1470.8 1104.05C1471.13 1102.01 1470.45 1100.52 1468.97 1099.76C1467.83 1099.17 1466.6 1098.72 1465.41 1098.21C1465.06 1098.07 1464.62 1097.99 1464.92 1097.35C1465.15 1096.88 1465.53 1097 1465.85 1097C1467.13 1096.96 1468.38 1096.99 1469.67 1096.89C1471.71 1096.73 1473.33 1095.49 1474.6 1093.34C1475.55 1091.75 1476.26 1090.1 1476.95 1088.44C1477.18 1087.9 1477.41 1087.31 1478.01 1087.32C1478.6 1087.33 1478.53 1087.9 1478.45 1088.47C1478.28 1089.45 1478.16 1090.44 1478 1091.43C1477.3 1095.6 1478.65 1098.39 1481.17 1100.43C1481.77 1100.91 1482.7 1101.03 1482.93 1102.4Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_169_428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 1124,
    width: 29,
    height: 30
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3936 1127.95L31.7511 1153.46L13.0013 1150.32L22.6437 1124.82L41.3936 1127.95Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_169_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0846 1141.98C34.2657 1142.09 32.8627 1141.73 31.4121 1141.59C29.6989 1141.43 28.4192 1142.44 27.1548 1143.78C25.9172 1145.1 24.827 1146.57 23.9011 1148.16C23.6186 1148.64 23.4131 1149.24 22.7989 1149.41C22.2637 1148.9 22.766 1148.12 23.0035 1147.52C23.5433 1146.21 23.7573 1144.9 23.9545 1143.63C24.287 1141.59 23.609 1140.1 22.1289 1139.34C20.9894 1138.75 19.7579 1138.3 18.5661 1137.79C18.2171 1137.65 17.7782 1137.57 18.0787 1136.93C18.3066 1136.46 18.6917 1136.58 19.0082 1136.58C20.2879 1136.54 21.5423 1136.57 22.8288 1136.47C24.8712 1136.31 26.4923 1135.07 27.7622 1132.92C28.7065 1131.33 29.4143 1129.68 30.1128 1128.02C30.3384 1127.48 30.5716 1126.89 31.1686 1126.9C31.7613 1126.91 31.6927 1127.48 31.6056 1128.05C31.4361 1129.03 31.3169 1130.02 31.1566 1131.01C30.4626 1135.18 31.8075 1137.97 34.3305 1140.01C34.9246 1140.49 35.8605 1140.61 36.0846 1141.98Z",
    fill: "#FAFAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars2);
export default __webpack_public_path__ + "static/media/stars2.b8f821a4d4fdf20710c4659ebd7b0ca6.svg";
export { ForwardRef as ReactComponent };